export const translations = {
  en: {
    // Navbar
    nav: {
      features: 'Features',
      resources: 'Resources',
      library: 'Library',
      pricing: 'Pricing',
      login: 'Log In',
      signup: 'Sign Up'
    },
    
    // Features dropdown
    featuresMenu: {
      algorithms: 'Algorithms',
      algorithmsDesc: 'Advanced prediction algorithms for the markets',
      aiPredictions: 'Risk & Behavior Analysis',
      aiPredictionsDesc: 'Analysis of major stock indices and cryptocurrencies'
    },
    
    // Resources dropdown
    resourcesMenu: {
      docs: 'Documentation',
      docsDesc: 'Learn how our algorithms work',
      community: 'Community',
      communityDesc: 'Join our users community'
    },
    
    // Hero Section
    hero: {
      title1: 'Analysis and Research Modeling Services',
      title2: ' Heliophant ',
      subtitle: 'Structured market analysis and investment risk assessment with high statistical consistency for stock indices and cryptocurrencies.',
      cta: 'Try 30 Days completely free',
      partnership: 'In collaboration with'
    },
    
    // Features Section
    features: {
      advancedAlgos: {
        badge: 'Quantitative Models',
        title: 'Complex market analysis tools',
        description: 'Our proprietary computational models study market dynamics through stochastic patterns, statistical fluctuations, and historical structures. The goal is not prediction with certainty, but understanding the behavior of highly complex systems and finding the golden ratio between low risk and maximum return.',
        cta: 'Explore the Methodology',
        stockMarket: 'Market Index Analysis',
        stockMarketDesc: 'Study of structure and volatility of major indices',
        bitcoinPrice: 'Bitcoin Analysis',
        bitcoinPriceDesc: 'Statistical approach to digital markets',
        realTime: 'Continuous Observation',
        realTimeDesc: 'Real-time regime updates'
      },
      nextGen: {
        badge: 'Next-Generation Mathematical Models',
        title1: 'Quantitative algorithmic analysis',
        title2: 'of complex systems',
        description: 'Heliophant applies mathematical and statistical tools to study markets as dynamic systems. It does not attempt to replace your judgment, but to enhance it through structured information.',
        cta: 'Get Access Now',
        accuracy: 'Statistical Accuracy',
        btcUsd: 'BTC/USD',
        bullish: 'Bearish',
        bullishDesc: 'Increased probability of bearish dynamics in the next period',
        sp500: 'S&P 500',
        neutral: 'Equilibrium Regime',
        neutralDesc: 'Neutrality phase with reduced directionality'
      },
      precisionAlerts: {
        badge: 'Precision Alerts',
        title1: 'Your edge,',
        title2: 'automated in real time',
        description: 'Receive alerts when analytical models detect significant changes in market structure or dynamics. Alerts are not instructions, but observation signals.',
        cta: 'Start Now',
        btcAlert: 'BTC Alert',
        btcAlertDesc: 'Volatility regime shift from bearish to neutral',
        nasdaqAlert: 'NASDAQ Alert',
        nasdaqAlertDesc: 'Neutral trend',
        ethAlert: 'ETH Alert',
        ethAlertDesc: 'Bearish to neutral'
      }
    },
    
    // Pricing Section
    pricing: {
      title: 'Analytical report access levels',
      monthly: 'Monthly',
      yearly: 'Yearly',
      monthLabel: 'month',
      yearLabel: 'year',
      premium: {
        name: 'Basic Plan',
        description: 'Access to core analytical reports and the Momentum Volatility ST Indicator for S&P500 and BTC',
        features: [
          'Access to the Momentum Volatility ST Indicator via TradingView platform',
          'Market research and stock trend analysis (S&P500)',
          'Digital asset analysis (BTC)',
          'Email alerts for significant trend changes'
        ],
        cta: 'Subscribe'
      },
      ultimate: {
        name: 'Professional Plan',
        popular: 'Extended Access',
        description: 'Access to the Momentum Volatility ST Indicator for multiple indexes and cryptocurrencies and automated real-time trend change alerts with premium support',
        priceLabel: 'Pricing upon agreement',
        features: [
          'Access to the Momentum Volatility ST Indicator via TradingView platform',
          'Everything in the Basic Plan',
          'Real-time trend change alerts',
          'Multi-market analysis (S&P500, Nasdaq, Russell, Euro50, China etc)',
          'Multi-digital asset analysis (BTC, ETH, SOL, AVAX, SUI, SEI, ADA etc)',
          'Priority technical support',
          'Custom alert configurations',
          'API access'
        ],
        cta: 'Subscribe'
      },
      guarantee: '',
      secureCheckout: 'Safe and secure checkout',
      secureDesc: 'Cancel anytime in one click from your account. An instant access link is provided immediately after registration. Our services provide analytical tools, not investment advice.'
    },
    
    // FAQ Section
    faq: {
      title: 'Frequently asked questions',
      questions: [
        {
          q: 'How accurate are Heliophant\'s predictive analyses?',
          a: 'Our algorithm maintains a high accuracy rate in predicting major market movements. While no prediction system is 100% accurate, our advanced stochastic analysis models of nonlinear dynamic systems consistently identify trends and price movements with remarkable precision.'
        },
        {
          q: 'Which markets do you cover?',
          a: 'We currently provide predictive analyses for major stock market indices and the most significant cryptocurrencies. Our coverage is continuously expanding based on user demand.'
        },
        {
          q: 'How do I receive the predictive analyses?',
          a: 'Predictive analyses are delivered through our platform, email notifications, and for Ultimate subscribers, via real-time alerts and API access. You can customize your notification preferences in your account settings.'
        },
        {
          q: 'Can I cancel my subscription anytime?',
          a: 'Yes, you can cancel your subscription at any time with no questions asked. Your access will continue until the end of your current billing period.'
        },
        {
          q: 'Is this suitable for beginners?',
          a: 'Absolutely! Our predictive analyses are presented in a clear, easy-to-understand format. In the future, we will also provide educational resources and community support to help beginners make the most of our service.'
        },
        {
          q: 'What makes Heliophant different from other similar services?',
          a: 'Our proprietary algorithm combines multiple data sources, advanced machine learning, and stochastic market analysis through mathematical models applied to nonlinear dynamic systems in real time to deliver predictive analyses with exceptional accuracy. We focus on actionable insights rather than overwhelming users with data.'
        }
      ]
    },
    
    // CTA Section
    cta: {
      exploreTitle: 'Explore all features',
      exploreDesc: 'Learn how Heliophant works and how you can upgrade your investment risk management to the next level.',
      exploreCta: 'Explore Features',
      planTitle: 'Choose a plan',
      planDesc: 'Get a plan that suits your style and upgrade your analysis.',
      planCta: 'Choose Plan'
    },
    
    // Footer
    footer: {
      tagline: 'Legal form: Sole Proprietorship. Activity: Research and development services in natural sciences. GEMI No.: 186174316000. Contact: contact@heliophant.com',
      product: 'Product',
      resources: 'Resources',
      company: 'Company',
      links: {
        pricing: 'Pricing',
        features: 'Features',
        algorithms: 'Algorithms',
        riskBehavior: 'Risk & Behavior Analysis',
        docs: 'Documentation',
        about: 'About',
        community: 'Community',
        affiliates: 'Affiliates',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
        disclaimer: 'Disclaimer',
        contact: 'Contact'
      },
      disclaimer: 'The platform provides data analysis and interpretation tools. It does not provide investment advice or automated trade execution. Markets are complex systems with inherent uncertainty.',
      copyright: '© 2026 Heliophant. All rights reserved.'
    },
    
    // About Section
    about: {
      title: 'Heliophant Market Algo',
      tagline: 'Mathematical analysis of financial markets as nonlinear dynamic systems.',
      problem: {
        badge: 'The Problem',
        title1: 'Market Complexity',
        title2: 'Without Clarity',
        description: 'Investors today face an unprecedented volume of market data and information overload. Without proper tools for analysis and structure, this wealth of information becomes a liability rather than an asset. The result? Reactive trading, inconsistent strategies, and unavoidable losses.',
        cardTitle: 'The Challenge',
        cardText: 'Modern financial and cryptocurrency markets produce enormous amounts of data, yet most investors lack clear, structured, and transparent analytical tools.',
        bullet1: 'Information overload without clear structure',
        bullet2: 'Opaque and controversial trading signals lacking transparency',
        bullet3: 'Emotion-driven decisions instead of data analysis',
        bullet4: 'Poor risk management and inconsistent results'
      },
      solution: {
        badge: 'Our Solution',
        title1: 'From Data',
        title2: 'to Understanding',
        description: 'Heliophant Market Algo transforms raw market data into practical knowledge. Heliophant Market Algo approaches markets as observable nonlinear dynamic systems. Through computational stochastic models and statistical analysis, raw data is transformed into interpretable structures.',
        focus: 'The focus is on decision support, not blind automation.',
        cardTitle: 'Our Services Deliver',
        feature1Title: 'Quantitative Market Analysis',
        feature1Desc: 'Advanced trend assessment and forecasts based on historical data',
        feature2Title: 'Risk Sensitivity Indicators',
        feature2Desc: 'Risk comprehension and management framework',
        feature3Title: 'Decision Support',
        feature3Desc: 'Revealing market structure and direction in a simple and transparent way',
        feature4Title: 'Modular Research Architecture',
        feature4Desc: 'Designed for continuous expansion, experimentation, and evolution'
      },
      whoFor: {
        badge: 'Who It\'s For',
        title1: 'Designed for',
        title2: 'Disciplined Investors seeking access to reliable data and risk reduction',
        card1Title: 'Independent Investors',
        card1Desc: 'Medium and long-term investors who value systematic analysis and strategic planning.',
        card2Title: 'Digital Asset Participants',
        card2Desc: 'Cryptocurrency market participants seeking clarity in volatile and complex digital asset markets.',
        card3Title: 'Professionals & Researchers',
        card3Desc: 'Financial professionals and researchers seeking analytical clarity and data-driven methodologies.',
        tagline: 'For users who value understanding, discipline, and awareness of uncertainty.'
      },
      why: {
        badge: 'Why Choose Us',
        title: 'Why Heliophant Market Algo',
        feature1Title: 'Scientific Foundation',
        feature1Desc: 'Based on quantitative analysis and rigorous methodology, not market hype or speculation. Every indicator is grounded in statistical principles and advanced mathematical models.',
        feature2Title: 'Transparency First',
        feature2Desc: 'Every analysis is explainable, verifiable, and designed for your understanding.',
        feature3Title: 'Risk as the First Parameter',
        feature3Desc: 'Structure before execution. Risk management is built into every analysis, ensuring you understand potential downsides before making decisions.',
        feature4Title: 'Scalable Platform',
        feature4Desc: 'Continuously evolving toward advanced analytics and future SaaS services. Our modular architecture grows with your needs and market developments.'
      }
    },

    // Contact Form
    contact: {
      title: 'Contact Us',
      subtitle: 'Have a question or want to learn more? Send us a message and we will get back to you.',
      phoneLabel: 'Phone',
      phone: '+30 6943893076',
      emailLabel: 'Email',
      email: 'contact@heliophant.com',
      name: 'Your Name',
      email_placeholder: 'Your Email',
      subject: 'Subject',
      message: 'Your Message',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Your message was sent successfully! We will get back to you soon.',
      error: 'Failed to send. Please try again.'
    }
  },
  
  el: {
    // Πλοήγηση
    nav: {
      features: 'Χαρακτηριστικά',
      resources: 'Πόροι',
      library: 'Βιβλιοθήκη',
      pricing: 'Κόστος',
      login: 'Σύνδεση',
      signup: 'Εγγραφή'
    },
    
    // Μενού Χαρακτηριστικών
    featuresMenu: {
      algorithms: 'Αλγόριθμοι',
      algorithmsDesc: 'Προηγμένοι αλγόριθμοι πρόβλεψης για τις αγορές',
      aiPredictions: 'Ανάλυση Ρίσκου & Συμπεριφοράς',
      aiPredictionsDesc: 'Ανάλυση βασικών χρηματιστηριακών δεικτών και κρυπτονομισμάτων'
    },
    
    // Μενού Πόρων
    resourcesMenu: {
      docs: 'Τεκμηρίωση',
      docsDesc: 'Μάθετε πώς λειτουργούν οι αλγόριθμοί μας',
      community: 'Κοινότητα',
      communityDesc: 'Γίνετε μέλος της κοινότητας των χρηστών μας'
    },
    
    // Κεντρική Ενότητα
    hero: {
      title1: 'Υπηρεσίες Ανάλυσης και Ερευνητικής Μοντελοποίησης',
      title2: ' Heliophant ',
      subtitle: 'Δομημένη ανάλυση αγορών και επενδυτικού κινδύνου υψηλής στατιστικής συνέπειας για χρηματιστηριακούς δείκτες και κρυπτονομίσματα.',
      cta: 'Δοκιμάστε 30 Μέρες εντελώς δωρεάν',
      partnership: 'Σε συνεργασία με'
    },
    
    // Ενότητα Χαρακτηριστικών
     features: {
       advancedAlgos: {
       badge: 'Ποσοτικά Μοντέλα',
       title: 'Εργαλεία ανάλυσης σύνθετων αγορών',
       description: 'Τα ιδιόκτητα υπολογιστικά μας μοντέλα μελετούν τη δυναμική των αγορών μέσω στοχαστικών μοτίβων, στατιστικών διακυμάνσεων και ιστορικών δομών. Στόχος δεν είναι η πρόβλεψη με βεβαιότητα, αλλά η κατανόηση της συμπεριφοράς συστημάτων υψηλής πολυπλοκότητας και η χρυσή τομή μεταξύ χαμηλού ρίσκου και μέγιστου κέρδους.',
       cta: 'Εξερευνήστε τη Μεθοδολογία',
       stockMarket: 'Ανάλυση Δεικτών Αγοράς',
       stockMarketDesc: 'Μελέτη δομής και μεταβλητότητας κύριων δεικτών',
       bitcoinPrice: 'Ανάλυση Bitcoin',
       bitcoinPriceDesc: 'Στατιστική προσέγγιση ψηφιακών αγορών',
       realTime: 'Συνεχής Παρατήρηση',
       realTimeDesc: 'Ενημέρωση καθεστώτων σε πραγματικό χρόνο'
       },
      nextGen: {
        badge: 'Μαθηματικά Μοντέλα Νέας Γενιάς',
        title1: 'Ποσοτική αλγοριθμική ανάλυση',
        title2: 'σύνθετων συστημάτων',
        description: 'Το Heliophant εφαρμόζει μαθηματικά και στατιστικά εργαλεία για τη μελέτη αγορών ως δυναμικών συστημάτων. Δεν επιχειρεί να αντικαταστήσει την κρίση σας, αλλά να την ενισχύσει μέσω δομημένης πληροφορίας.',
        cta: 'Αποκτήστε Πρόσβαση Τώρα',
        accuracy: 'Στατιστική Ακρίβεια',
        btcUsd: 'BTC/USD',
        bullish: 'Καθοδικό',
        bullishDesc: 'Αύξηση πιθανότητας καθοδικής δυναμικής το επόμενο δάστημα',
        sp500: 'S&P 500',
        neutral: 'Καθεστώς Ισορροπίας',
        neutralDesc: 'Φάση ουδετερότητας και μειωμένης κατεύθυνσης'
      },
      precisionAlerts: {
        badge: 'Ειδοποιήσεις Ακριβείας',
        title1: 'Το πλεονέκτημά σας,',
        title2: 'σε πραγματικό χρόνο αυτοματοποιημένα',
        description: 'Λάβετε ειδοποιήσεις όταν τα αναλυτικά μοντέλα εντοπίσουν σημαντική μεταβολή στη δομή ή τη δυναμική της αγοράς. Οι ειδοποιήσεις δεν αποτελούν οδηγίες, αλλά σήματα παρατήρησης.',
        cta: 'Ξεκινήστε Τώρα',
        btcAlert: 'Ειδοποίηση BTC',
        btcAlertDesc: 'Μεταβολή καθεστώτος μεταβλητότητας από καθοδική σε ουδέτερη ',
        nasdaqAlert: 'Ειδοποίηση NASDAQ',
        nasdaqAlertDesc: 'Ουδέτερη τάση',
        ethAlert: 'Ειδοποίηση ETH',
        ethAlertDesc: 'Καθοδική προς ουδέτερη'
      }
    },
    
    // Ενότητα Τιμολόγησης
    pricing: {
      title: 'Επίπεδα πρόσβασης στην αναλυτική αναφορά',
      monthly: 'Μηνιαία',
      yearly: 'Ετήσια',
      monthLabel: 'μήνα',
      yearLabel: 'έτος',
      premium: {
        name: 'Basic Plan',
        description: 'Πρόσβαση σε βασικές αναλυτικές αναλύσεις και τον Momentum Volatility ST Indicator για τον S&P500 και το BTC',
        features: [
          'Πρόσβαση στον Αλγόριθμο Momentum Volatility ST Indicator μέσω της πλατφόρμας Trading View',
          'Ανάλυση του κεντρικού χρηματηστηριακού δείκτη S&P500',
          'Ανάλυση του BTC',
          'Ειδοποιήσεις email για σημαντικές μεταβολές τάσεων σε S&P500 και BTC'
        ],
        cta: 'Εγγραφή'
      },
      ultimate: {
        name: 'Professional Plan',
        popular: 'Εκτεταμένη Πρόσβαση',
        description: 'Πρόσβαση στον Momentum Volatility ST Indicator σε πληθώρα δεικτών και κρυπτονομισμάτων και αυτοματοποιημένες ειδοποιήσεις μεταβολής τάσεων σε πραγματικό χρόνο και premium υποστήριξη',
        priceLabel: 'Τιμολόγηση κατόπιν συνεννόησης',
        features: [
          'Πρόσβαση στον Αλγόριθμο Momentum Volatility ST Indicator μέσω της πλατφόρμας Trading View',
          'Όλα όσα στο Basic Plan',
          'Ειδοποιήσεις αλλαγής τάσεων σε πραγματικό χρόνο',
          'Ανάλυση πολλαπλών αγορων (S&P500, Nasdaq, Russel, Euro50, China etc)',
          'Μελέτη πολλαπλών ψηφιακών περιουσιακών στοιχείων (BTC, ETH, SOL, AVAX, SUI, SEI, ADA etc)',
          'Τεχνική Υποστήριξη με προτεραιότητα',
          'Προσαρμοσμένες διαμορφώσεις ειδοποιήσεων',
          'Πρόσβαση μέσω API'
        ],
        cta: 'Εγγραφή'
      },
      guarantee: '',
      secureCheckout: 'Ασφαλής και προστατευμένη αγορά',
      secureDesc: 'Ακυρώστε ανά πάσα στιγμή με ένα κλικ από τον λογαριασμό σας. Ένας σύνδεσμος για άμεση πρόσβαση παρέχεται αμέσως μετά την εγγραφή. Οι υπηρεσίες μας παρέχουν αναλυτικά εργαλεία και όχι επενδυτικές οδηγίες.'
    },
    
    // Ενότητα Συχνών Ερωτήσεων
    faq: {
      title: 'Συχνές ερωτήσεις',
      questions: [
        {
          q: 'Πόσο ακριβείς είναι οι προγνωστικές αναλύσεις του Heliophant;',
          a: 'Ο αλγόριθμός μας διατηρεί υψηλό ποσοστό ακρίβειας στην πρόβλεψη σημαντικών κινήσεων της αγοράς. Ενώ κανένα σύστημα πρόβλεψης δεν είναι 100% ακριβές, τα προηγμένα μοντέλα στοχαστικής ανάλυσης μη γραμμικών δυναμικών συστημάτων μας εντοπίζουν συνεχώς τάσεις και κινήσεις τιμών με αξιοσημείωτη ακρίβεια.'
        },
        {
          q: 'Ποιες αγορές καλύπτετε;',
          a: 'Αυτή τη στιγμή παρέχουμε προγνωστικές αναλύσεις για σημαντικούς δείκτες χρηματιστηρίου και τα σημαντικότερα κρυπτονομίσματα. Η κάλυψή μας επεκτείνεται συνεχώς με βάση τη ζήτηση των χρηστών.'
        },
        {
          q: 'Πώς λαμβάνω τις προγνωστικές αναλύσεις;',
          a: 'Οι προγνωστικές αναλύσεις παραδίδονται μέσω της πλατφόρμας μας, ειδοποιήσεων email και για συνδρομητές Professional, μέσω ειδοποιήσεων πραγματικού χρόνου και πρόσβασης API. Μπορείτε να προσαρμόσετε τις προτιμήσεις ειδοποιήσεών σας στις ρυθμίσεις του λογαριασμού σας.'
        },
        {
          q: 'Μπορώ να ακυρώσω τη συνδρομή μου ανά πάσα στιγμή;',
          a: 'Ναι, μπορείτε να ακυρώσετε τη συνδρομή σας οποιαδήποτε στιγμή χωρίς ερωτήσεις. Η πρόσβασή σας θα συνεχιστεί μέχρι το τέλος της τρέχουσας περιόδου χρέωσης.'
        },
        {
          q: 'Είναι κατάλληλο για αρχάριους;',
          a: 'Απολύτως! Οι προγνωστικές αναλύσεις μας παρουσιάζονται σε σαφή, κατανοητή μορφή. Μελλοντικά, θα παρέχουμε επίσης εκπαιδευτικούς πόρους και υποστήριξη κοινότητας για να βοηθήσουμε τους αρχάριους να αξιοποιήσουν στο έπακρο την υπηρεσία μας.'
        },
        {
          q: 'Τι κάνει το Heliophant διαφορετικό από άλλες αντίστοιχες υπηρεσίες ;',
          a: 'Ο ιδιόκτητος αλγόριθμός μας συνδυάζει πολλαπλές πηγές δεδομένων, προηγμένη μηχανική μάθηση και στοχαστική ανάλυση αγοράς μέσω μαθηματικών μοντέλων που εφαρμόζονται σε μη γραμμικά δυναμικά συστήματα, σε πραγματικό χρόνο για να παρέχει προγνωστικές αναλύσεις με εξαιρετική ακρίβεια. Εστιάζουμε σε πρακτικές πληροφορίες αντί να κατακλύζουμε τους χρήστες με δεδομένα.'
        }
      ]
    },
    
    // Ενότητα Κλήσης σε Δράση
    cta: {
      exploreTitle: 'Εξερευνήστε όλα τα χαρακτηριστικά',
      exploreDesc: 'Μάθετε πώς λειτουργεί το Heliophant και πώς μπορείτε να αναβαθμίσετε την διαχείρηση επενδυτικού ρίσκου του κεφαλάιου σας στο επόμενο επίπεδο.',
      exploreCta: 'Εξερευνήστε Χαρακτηριστικά',
      planTitle: 'Επιλέξτε ένα πλάνο',
      planDesc: 'Αποκτήστε ένα πλάνο που ταιριάζει στο στυλ σας και αναβαθμίστε την ανάλυσή σας.',
      planCta: 'Επιλέξτε Πλάνο'
    },
    
    // Υποσέλιδο
    footer: {
      tagline: 'Νομική μορφή: Ατομική Επιχείρηση. Δραστηριότητα: Υπηρεσίες έρευνας και ανάπτυξης στις φυσικές επιστήμες. Αριθμός ΓΕΜΗ.: 186174316000 . Επικοινωνία: contact@heliophant.com ',
      product: 'Προϊόν',
      resources: 'Πόροι',
      company: 'Εταιρεία',
      links: {
        pricing: 'Τιμολόγηση',
        features: 'Χαρακτηριστικά',
        algorithms: 'Αλγόριθμοι',
        riskBehavior: 'Ανάλυση Ρίσκου και Συμπεριφοράς',
        docs: 'Τεκμηρίωση',
        about: 'Σχετικά',
        community: 'Κοινότητα',
        affiliates: 'Συνεργάτες',
        terms: 'Όροι Χρήσης',
        privacy: 'Πολιτική Απορρήτου',
        disclaimer: 'Αποποίηση Ευθύνης',
        contact: 'Επικοινωνία'
      },
      disclaimer: 'Η πλατφόρμα παρέχει εργαλεία ανάλυσης και ερμηνείας δεδομένων. Δεν παρέχει επενδυτικές συμβουλές ούτε αυτοματοποιημένη εκτέλεση συναλλαγών. Οι αγορές αποτελούν σύνθετα συστήματα με εγγενή αβεβαιότητα.',
      copyright: '© 2026 Heliophant. Με επιφύλαξη παντός δικαιώματος.'
    },
    
    // Ενότητα Σχετικά
    about: {
      title: 'Heliophant Market Algo',
      tagline: 'Μαθηματική ανάλυση των χρηματηστηριακών αγορών ως μη γραμμικών δυναμικών συστημάτων.',
      problem: {
        badge: 'Το Πρόβλημα',
        title1: 'Πολυπλοκότητα Αγοράς',
        title2: 'Χωρίς Σαφήνεια',
        description: 'Οι επενδυτές σήμερα αντιμετωπίζουν πρωτοφανή όγκο δεδομένων αγοράς και υπερπληροφορίας. Χωρίς τα κατάλληλα εργαλεία ανάλυσης και δομής, αυτός ο πλούτος πληροφοριών γίνεται ελλάτωμα αντί για πλεονέκτημα. Το αποτέλεσμα; Αντιδραστικό trading, ασυνεπείς στρατηγικές και αναπόφευκτες απώλειες.',
        cardTitle: 'Η Πρόκληση',
        cardText: 'Οι σύγχρονες χρηματοοικονομικές και κρυπτονομισματικές αγορές παράγουν τεράστιες ποσότητες δεδομένων, ωστόσο οι περισσότεροι επενδυτές στερούνται σαφών, δομημένων και διαφανών αναλυτικών εργαλείων.',
        bullet1: 'Υπερφόρτωση πληροφοριών χωρίς σαφή δομή',
        bullet2: 'Αδιαφανή και αμφιλεγόμενα σήματα συναλλαγών που στερούνται διαφάνειας',
        bullet3: 'Συναισθηματικές αποφάσεις αντί για ανάλυση δεδομένων',
        bullet4: 'Κακή διαχείριση κινδύνου και ασυνεπή αποτελέσματα'
      },
      solution: {
        badge: 'Η Λύση μας',
        title1: 'Από τα Δεδομένα',
        title2: 'στην Κατανόηση',
        description: 'Το Heliophant Market Algo μετατρέπει ακατέργαστα δεδομένα αγοράς σε πρακτική γνώση. Το Heliophant Market Algo προσεγγίζει τις αγορές ως παρατηρήσιμα μη γραμμικά δυναμικά συστήματα. Μέσω υπολογιστικών στοχαστικών μοντέλων και στατιστικής ανάλυσης, τα ακατέργαστα δεδομένα μετασχηματίζονται σε ερμηνεύσιμες δομές.',
        focus: 'Η εστίαση είναι στην υποστήριξη αποφάσεων, όχι απλώς στον τυφλό αυτοματισμό.',
        cardTitle: 'Οι Υπηρεσίες μας Παρέχουν',
        feature1Title: 'Ποσοτική Ανάλυση Αγοράς',
        feature1Desc: 'Προηγμένη αξιολόγηση τάσεων και προγνώσεις βασισμένες σε ιστορικά δεδομένα',
        feature2Title: 'Δείκτες Ευαισθησίας Κινδύνου',
        feature2Desc: 'Πλαίσιο Κατανόησης και διαχείρισης κινδύνου',
        feature3Title: 'Υποστήριξη Αποφάσεων',
        feature3Desc: 'Φανέρωση δομής και κατεύθυνσης αγορών με απλό και διαφανή τρόπο',
        feature4Title: 'Αρθρωτή Ερευνητική Αρχιτεκτονική',
        feature4Desc: 'Σχεδιασμένη για συνεχή επέκταση, πειραματισμό και εξέλιξη'
      },
      whoFor: {
        badge: 'Για Ποιους',
        title1: 'Σχεδιασμένο για',
        title2: 'Πειθαρχημένους Επενδυτές που θέλουν πρόσβαση σε αξιόπιστα στοιχεία και μείωση ρίσκου',
        card1Title: 'Ανεξάρτητοι Επενδυτές',
        card1Desc: 'Μεσοπρόθεσμοι και Μακροπρόθεσμοι επενδυτές που εκτιμούν τη συστηματική ανάλυση και τον στρατηγικό σχεδιασμό. ',
        card2Title: 'Συμμετέχοντες σε ψηφιακά περιουσιακά στοιχεία',
        card2Desc: 'Συμμετέχοντες στην αγορά κρυπτονομισμάτων που αναζητούν σαφήνεια σε ασταθείς και πολύπλοκες αγορές ψηφιακών περιουσιακών στοιχείων.',
        card3Title: 'Επαγγελματίες & Ερευνητές',
        card3Desc: 'Χρηματοοικονομικοί επαγγελματίες και ερευνητές που αναζητούν αναλυτική σαφήνεια και μεθοδολογίες βασισμένες σε δεδομένα.',
        tagline: 'Για απλούς χρήστες που εκτιμούν την κατανόηση, την πειθαρχία και την επίγνωση της αβεβαιότητας.'
      },
      why: {
        badge: 'Γιατί να μας Επιλέξετε',
        title: 'Γιατί το Heliophant Market Algo',
        feature1Title: 'Επιστημονική Βάση',
        feature1Desc: 'Βασισμένο σε ποσοτική ανάλυση και αυστηρή μεθοδολογία, όχι σε διαφημιστικό θόρυβο ή εικασίες της αγοράς. Κάθε δείκτης βασίζεται σε στατιστικές αρχές και προηγμένα μαθηματικά μοντέλα.',
        feature2Title: 'Διαφάνεια Πρώτα',
        feature2Desc: 'Κάθε ανάλυση είναι επεξηγήσιμη, επαληθεύσιμη και σχεδιασμένη για την κατανόησή σας.',
        feature3Title: 'Κίνδυνος ως Πρώτη Παράμετρος',
        feature3Desc: 'Δομή πριν την εκτέλεση. Η διαχείριση κινδύνου είναι ενσωματωμένη σε κάθε ανάλυση, διασφαλίζοντας ότι κατανοείτε τα πιθανά μειονεκτήματα πριν λάβετε αποφάσεις.',
        feature4Title: 'Επεκτάσιμη Πλατφόρμα',
        feature4Desc: 'Εξελίσσεται συνεχώς προς προηγμένη αναλυτική και μελλοντικές υπηρεσίες SaaS. Η αρθρωτή μας αρχιτεκτονική αναπτύσσεται με τις ανάγκες σας και τις εξελίξεις της αγοράς.'
      }
    },

    // Φόρμα Επικοινωνίας
    contact: {
      title: 'Επικοινωνήστε μαζί μας',
      subtitle: 'Έχετε κάποια ερώτηση ή θέλετε να μάθετε περισσότερα; Στείλτε μας μήνυμα και θα επικοινωνήσουμε μαζί σας.',
      phoneLabel: 'Τηλέφωνο',
      phone: '+30 6943893076',
      emailLabel: 'Email',
      email: 'contact@heliophant.com',
      name: 'Το Όνομά σας',
      email_placeholder: 'Το Email σας',
      subject: 'Θέμα',
      message: 'Το Μήνυμά σας',
      send: 'Αποστολή',
      sending: 'Αποστολή...',
      success: 'Το μήνυμά σας στάλθηκε επιτυχώς! Θα επικοινωνήσουμε μαζί σας σύντομα.',
      error: 'Αποτυχία αποστολής. Παρακαλώ δοκιμάστε ξανά.'
    }
  }
};
